import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    localWeather: {},
    categoryTotal: {},
    articlesTotal : {},
    articlesTimeline:{},
    blogPath:""
  },
  getters: {
    categoryTotal: state => state.categoryTotal,
    articlesTotal : state => state.articlesTotal,
    articlesTimeline : state => state.articlesTimeline,
    localWeather : state => state.localWeather,
    blogPath : state => state.blogPath,
  },
  mutations: {
    setCategoryTotal: (state, data) => {
      state.categoryTotal = data;
    },
    setArticlesTotal: (state, data) => {
      state.articlesTotal = data;
    },
    setLocalWeather: (state, data) => {
      state.localWeather = data;
    },
    setArticlesTimeline: (state, data) => {
      state.articlesTimeline = data;
    },
    setBlogPath: (state, data) => {
      state.blogPath = data;
    },
  },
  actions: {
  },

})
